import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ProblemDetail from './pages/ProblemDetail';
import CreateProblem from './pages/CreateProblem';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/problems/new" element={<CreateProblem />} />
        <Route path="/problems/:id" element={<ProblemDetail />} />
      </Routes>
    </div>
  );
}

export default App;
